
import React, { useContext, useState } from "react";
import { DialogContext, DialogProviderValue } from "components/Shared/DialogProvider";
import ReorderableGrid, { ReorderableItem } from "components/Shared/ReorderableGrid";

const JordanTestPage = () => {
  const dialog = useContext<DialogProviderValue>(DialogContext);
  const ii = Array.from({ length: 80 }, (_, i) => {
    const r = ((i >> 2) & 1) * 255; // bit 3
    const g = ((i >> 1) & 1) * 255; // bit 2
    const b = (i & 1) * 255;        // bit 1
    const bg = `rgb(${r}, ${g}, ${b})`;
    const fg = getTextColor(r, g, b);

    return {
      id: "i"+i,
      node: (
        <div
          key={i}
          style={{
            background: bg,
            color: fg,
            height: 64,
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            width: "50px",
            // width: ((i % 5 + 1) * 10) + "px",
          }}
        >
          {i}
        </div>
      )};
  });

  const [items, setItems] = useState<ReorderableItem[]>(ii);

  const ohNo = () => {
    dialog.show("oh no", <ReorderableGrid
      items={items}
      onReorder={(nextIds) => {
        const map = new Map(items.map(i => [i.id, i]));
        setItems(nextIds.map(id => map.get(id)!));
      }}
      className="my-list"
      itemClassName="my-item"
      layout="grid"
    />,
    null,
    { useFlexInsteadOfTransformForCentering: true });
  };

  return (<>
    <div onClick={ohNo}>oh no</div>
    <ReorderableGrid
      items={items}
      onReorder={(nextIds) => {
        const map = new Map(items.map(i => [i.id, i]));
        setItems(nextIds.map(id => map.get(id)!));
      }}
      className="my-list"
      itemClassName="my-item"
      layout="list"
    />
    </>
  );
}

// Simple black/white contrast switch (YIQ)
function getTextColor(r: number, g: number, b: number) {
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000" : "#fff";
}

export default JordanTestPage;
